// Recovered compiled webpack factory 68440. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      METADATA_BOUNDARY_NAME: function () {
        return r;
      },
      OUTLET_BOUNDARY_NAME: function () {
        return a;
      },
      ROOT_LAYOUT_BOUNDARY_NAME: function () {
        return o;
      },
      VIEWPORT_BOUNDARY_NAME: function () {
        return n;
      },
    }));
  let r = "__next_metadata_boundary__",
    n = "__next_viewport_boundary__",
    a = "__next_outlet_boundary__",
    o = "__next_root_layout_boundary__";
}
